import React, { useState, useRef, useEffect } from "react";
import { PiMountains } from "react-icons/pi";
import { FaHome, FaMap, FaBoxOpen, FaStore } from "react-icons/fa";

const tabs = [
  { name: "Home", icon: FaHome },
  { name: "Vendors", icon: FaStore },
  { name: "Plan", icon: PiMountains },
  { name: "Gear", icon: FaBoxOpen },
  { name: "Map", icon: FaMap },
];

const BottomNav = ({ currentTab, setCurrentTab }) => {
  const [planMenuOpen, setPlanMenuOpen] = useState(false);
  const planBtnRef = useRef(null);
  const menuRef = useRef(null);

  // Close menu on outside click
  useEffect(() => {
    function handleClick(e) {
      if (
        planMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        planBtnRef.current &&
        !planBtnRef.current.contains(e.target)
      ) {
        setPlanMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [planMenuOpen]);

  return (
    <nav
      className="fixed bottom-0 left-0 w-full h-[70px] bg-[#333] flex items-center justify-between px-2 z-[9999]"
      style={{ paddingTop: 10, zIndex: 9999 }}
      role="navigation"
      aria-label="Main navigation"
    >
      <ul className="flex w-full justify-evenly items-center h-full">
        {tabs.map((tab) => (
          <li key={tab.name} className="flex-1 relative">
            {tab.name === "Plan" ? (
              <>
                <button
                  ref={planBtnRef}
                  className={`flex flex-col items-center justify-center w-full h-full text-white font-bold focus:outline-none transition-colors duration-150 ${
                    currentTab === tab.name ? "bg-[#444]" : "bg-transparent"
                  }`}
                  onClick={() => setPlanMenuOpen((open) => !open)}
                  aria-current={currentTab === tab.name ? "page" : undefined}
                  aria-haspopup="true"
                  aria-expanded={planMenuOpen}
                >
                  <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", background: currentTab === tab.name ? "#2563eb" : "#333", borderRadius: 8, padding: 6, border: "2px solid #fff" }}>
                    <tab.icon className="w-6 h-6 mb-1" style={{ color: "#fff" }} />
                  </span>
                  <span className="text-xs">{tab.name}</span>
                </button>
                {planMenuOpen && (
                  <div
                    ref={menuRef}
                    role="menu"
                    tabIndex={-1}
                    className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 bg-[#222] rounded shadow-lg py-1 min-w-[220px] max-w-[320px] flex flex-col items-stretch border border-[#444] focus:outline-none max-h-[calc(100vh-70px)] overflow-y-auto z-[7]"
                  >
                    <button
                      className="block w-full text-left px-4 py-2 text-white hover:bg-[#444] transition-colors cursor-pointer font-bold select-none outline-none uppercase text-xs whitespace-nowrap overflow-hidden text-ellipsis"
                      tabIndex={0}
                      role="menuitem"
                      onClick={() => {
                        setCurrentTab('BLM Map Page');
                        setPlanMenuOpen(false);
                      }}
                    >
                      BLM Map Page
                    </button>
                    <button
                      className="block w-full text-left px-4 py-2 text-white hover:bg-[#444] transition-colors cursor-pointer font-bold select-none outline-none uppercase text-xs whitespace-nowrap overflow-hidden text-ellipsis"
                      tabIndex={0}
                      role="menuitem"
                      onClick={() => {
                        setCurrentTab('Plan');
                        setPlanMenuOpen(false);
                      }}
                    >
                      NPS Page
                    </button>
                    <div
                      className="block w-full text-left px-4 py-2 text-gray-400 font-bold select-none outline-none uppercase text-xs whitespace-nowrap overflow-hidden text-ellipsis cursor-not-allowed"
                      tabIndex={-1}
                      role="menuitem"
                      aria-disabled="true"
                    >
                      Bureau of Land Management (BLM) (Disabled)
                    </div>
                  </div>
                )}
              </>
            ) : (
              <button
                className={`flex flex-col items-center justify-center w-full h-full text-white font-bold focus:outline-none transition-colors duration-150 ${
                  currentTab === tab.name ? "bg-[#444]" : "bg-transparent"
                }`}
                onClick={() => setCurrentTab(tab.name)}
                aria-current={currentTab === tab.name ? "page" : undefined}
              >
                <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", background: currentTab === tab.name ? "#2563eb" : "#333", borderRadius: 8, padding: 6, border: "2px solid #fff" }}>
                  <tab.icon className="w-6 h-6 mb-1" style={{ color: "#fff" }} />
                </span>
                <span className="text-xs">{tab.name}</span>
              </button>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default BottomNav;
